<template>
  <div class="container" style="display: flex;flex-direction: column;gap: 10px;position: absolute;right: 0;top: 60px;z-index: 9000001;">
    <div class="popup"
      v-if="item.editorFlag"
      v-for="(item,index) in notifies" :key="index"
      style="display: flex;flex-direction: column;padding: 20px;
      box-shadow: rgba(0, 0, 0, 0.2) -5px 5px 20px;
      border-radius: 20px;background: #FFFFFF;min-width: 350px;
      max-width: 350px;border: 1px solid #DCDCDC;box-sizing: border-box;">
      <div class="popup-header" style="display: flex;align-items: center;">
        <img src="@/assets/tongzhi-icon.png" style="width: 24px;height: auto;padding-right: 6px;" alt="Icon">
        <div class="popup-title mly-ellipsis" style="color: rgba(0,0,0,0.9);font-size: 16px;font-weight: 600;">{{ item.title }}</div>
      </div>
      <div class="popup-content" style="color: rgba(0,0,0,0.6);font-size: 12px;text-align: justify;padding: 1rem 0 1rem 0;">
        <div class="mly-ellipsis2" v-html="item.content"></div>
      </div>
      <div class="popup-footer" style="display: flex;justify-content: space-between;align-items: center;">
        <div class="footer-left" style="color: rgba(0,0,0,0.4);font-size: 12px;">{{ item.startTime }}</div>
        <div class="footer-right">
          <el-button style="border-radius: 6px !important;padding: 0.5rem 1rem;" size="small" type="default"  @click="onCancel(item)">取消</el-button>
          <el-button style="border-radius: 6px !important;padding: 0.5rem 1rem;" size="small" type="primary"  @click="onConfirm(item)">查看</el-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import * as ArticleApi from '@/api/article'
import { mapState, mapMutations} from 'vuex'
export default {
  name: 'MessageNotify',
  props: {

  },
  mounted() {
    this.handleMessageNotify()
  },
  data() {
    return {
      items: [
        {
          createTime: '2025-06-14 12:20:51',
          content: '你可得5万能量，新用户可得10万能量',
          title: '如果你是首次邀请，你可获得10万能量'
        },
      ]
    }
  },
  computed: {
  	...mapState(['user', 'currentNotifyId', 'token', 'notifies'])
  },
  methods: {
    ...mapMutations(['setNotify', 'setCurrentNotifyId']),
    onCancel(item) {
      // item.showFlag = false
      this.$set(item, 'editorFlag', false)
    },
    onConfirm(item) {
      this.onCancel(item)
      this.setCurrentNotifyId(item.id)
      this.$router.push(`/newsdetail/${item.id}`)
    },
    hasSpecificObject(arr, targetObj) {
      return arr.some(item =>
        typeof item === 'object' &&
        item !== null &&
        !Array.isArray(item) &&
        JSON.stringify(item) === JSON.stringify(targetObj)
      );
    },
    handleMessageNotify() {
      ArticleApi.page({size: 3, editorFlag: true, articleGroup: 'MESSAGE', fromType: 'writer-web-notify'}).then(res => {
        let result = res.data.data.records;
        if(!Array.isArray(result)){
          return false
        }
        result.forEach((item,index) =>{
          this.notifies.forEach((item2,index2) =>{
            if(item2.id==item.id){
              item.editorFlag=item2.editorFlag
            }
          })
        })
        this.setNotify(result)
      })
    }
  }
};
</script>

<style scoped>

</style>
